import { SvgIcon } from "@/components/icon"
import { FC } from "react"
import "./HexagonGroup.less"

type Props = {
  id: string
  imageUrl?: string
  isTicked?: boolean
  isExclamation?: boolean
}

const HexagonGroup: FC<Props> = ({ id, imageUrl, isTicked, isExclamation }) => {
  return (
    <div className={"hexagon-group"}>
      <div className={"hexagon-wrapper"}>
        {/* small hex */}
        <div className={"hexagon-badge"}>
          <div className={"hexagon-badge-inner"}>
            {!isTicked ? <span>{id}</span> : <SvgIcon type={isExclamation ? "exclamation" : "blue-tick"} />}
          </div>
        </div>

        {/* main hex */}
        <div className={"hexagon-main"}>
          <div className={"hexagon-image-wrapper"}>
            <img src={imageUrl} alt={""} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HexagonGroup
